<template>
  <footer class="footer">
    <div class="row text-center">
      <div class="col-3 m2 p2">
        <div class="footer-btns">
          <router-link :to="`/${device}/dashboard`">
            <i :class="`bx bx-home-circle font-size-24 ${homeTextColor}`"></i>
          </router-link>
        </div>
      </div>
      <div class="col-3">
        <div class="footer-btns">
          <router-link :to="`/${device}/incidents`">
            <i :class="`bx bx-car font-size-24 ${incidentsTextColor}`"></i>
          </router-link>
        </div>
      </div>
      <div class="col-3">
        <div class="footer-btns">
          <router-link :to="`/${device}/emergency`">
            <i :class="`bx bx-wrench font-size-24 ${settingsTextColor}`"></i>
          </router-link>
        </div>
      </div>
      <div class="col-3">
        <div class="footer-btns">
          <i :class="`bx bx-user font-size-24 ${profileTextColor}`"></i>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
<script>
export default {
  data() {
    return {
      homeTextColor: "",
      incidentsTextColor: "",
      settingsTextColor: "",
      profileTextColor: "",
    };
  },

  computed: {
    device() {
      return this.$store.getters["gis/deviceType"] === "TABLET"
        ? "tablet"
        : "phone";
    },
    currentRouteName() {
      return this.$route.name;
    },
  },

  mounted() {
    this.setActiveLinkClass();
  },

  watch: {
    currentRouteName: function () {
      this.setActiveLinkClass();
    },
  },

  methods: {
    setActiveLinkClass() {
      this.incidentsTextColor = "";
      this.settingsTextColor = "";
      this.profileTextColor = "";
      this.homeTextColor = "";

      switch (this.currentRouteName) {
        case "dashboard":
          this.homeTextColor = "text-primary";
          break;
        case "profile":
          this.profileTextColor = "text-primary";
          break;
        case "settings":
          this.settingsTextColor = "text-primary";
          break;
        case "incidents":
          this.incidentsTextColor = "text-primary";
          break;
      }
    },
  },
};
</script >
<style >
.footer {
  position: fixed;
  background: #222736;
  height: 80px;
}

.footer-btns {
  padding: 10px;
  border-radius: 10px;
  background: #222736;
  box-shadow: 5px 5px 10px #1a1e29, -5px -5px 10px #2a3043;
}

.footer-btns:hover,
.footer-btns:focus,
.footer-btns:active {
  animation: clicked 0.5s;
}

@keyframes clicked {
  from {
    box-shadow: inset 12px 12px 24px #1b1f2b, inset -12px -12px 24px #292f41;
  }

  to {
    box-shadow: 5px 5px 10px #1a1e29, -5px -5px 10px #2a3043;
  }
}
</style>